import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { ArrowBackOutlined, EditOutlined } from '@mui/icons-material';
import FocusTrap from '@mui/material/Unstable_TrapFocus';
import SafeMarkdown from '../SafeMarkdown';
import { contextContentMarkdownBodySx } from '../markdownBodySx';
import { getContext } from '../../../services/api';

export default function KnowledgePreview({ context, onBack, backLabel, canEdit, onEdit }) {
  const [loaded, setLoaded] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true;
    setLoaded(null);
    setError(false);
    if (context.content != null && String(context.content).trim()) {
      setLoaded(context);
    } else {
      getContext(context.id).then((response) => {
        if (!current) return;
        const full = response?.context || response?.data || response;
        if (!full?.id) throw new Error('Missing knowledge');
        setLoaded({ ...context, ...full });
      }).catch(() => { if (current) setError(true); });
    }
    return () => { current = false; };
  }, [context, attempt]);
  return (
    <FocusTrap open>
    <Box tabIndex={-1} role="region" aria-label="Knowledge preview" onKeyDown={(event) => { if (event.key === 'Escape') { event.stopPropagation(); onBack(); } }} sx={{ position: 'absolute', inset: 0, zIndex: 2, bgcolor: 'background.paper', display: 'flex', flexDirection: 'column', p: { xs: 2, sm: 3 }, minHeight: 0 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flexShrink: 0, mb: 2 }}>
        <Button startIcon={<ArrowBackOutlined />} onClick={onBack}>{backLabel}</Button>
        {canEdit && loaded && <Button startIcon={<EditOutlined />} onClick={() => onEdit(loaded)}>Edit knowledge</Button>}
      </Box>
      <Box sx={{ overflow: 'auto', minHeight: 0, flex: 1 }}>
        <Typography variant="h6" sx={{ mb: 1, overflowWrap: 'anywhere' }}>{context.name}</Typography>
        {error ? <Alert severity="error" action={<Button onClick={() => setAttempt((value) => value + 1)}>Retry</Button>}>Unable to load knowledge.</Alert> : !loaded ? <CircularProgress size={24} aria-label="Loading knowledge" /> : (
          <>
            {loaded.description && <Typography color="text.secondary" sx={{ mb: 2 }}>{loaded.description}</Typography>}
            <Box sx={{ '& .markdown-body': contextContentMarkdownBodySx }}><SafeMarkdown>{loaded.content || 'No content'}</SafeMarkdown></Box>
          </>
        )}
      </Box>
    </Box>
    </FocusTrap>
  );
}
